import Carousel from 'react-bootstrap/Carousel';

function HealthCenter() {
  return (
    <Carousel  indicators={false} className="goals-carousel concrete-carousel" >
      
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="./images/28.jpeg"
          alt="Third slide"
        />
        
      </Carousel.Item>

       <Carousel.Item>
        <img
          className="d-block w-100"
          src="./images/29.jpeg"
          alt="Third slide"
        />
        
      </Carousel.Item>

    </Carousel>
  );
}

export default HealthCenter;